module.exports = __webpack_public_path__ + "img/sale.05a905d4.svg";